import React, { useState, useEffect, useContext } from "react";
import { useWalletProvider } from "../../../walletprovider/useWalletProvider";
import { WalletCurrency } from "../../../data/WalletCurrency";
import eye from "../../../assets/media/icons/eye.svg";
import eye_off from "../../../assets/media/icons/eye-off.svg";
import { WalletProviderContext } from "../../../walletprovider/WalletProvider";
import { DwMpcWalletBackendProviderContext } from "../../../mpcwalletprovider/DwMpcWalletBackendProvider";
import {
  collectLog,
  createEmptyLogsAndVars,
  dwReportError,
  recordVariable,
} from "../../../utils/diagnostics/clientErrors";

import { getUserProfileJwt } from "../../../utils/dwclient/dwclientutils";
import { loadJwt } from "../../../utils/dwclient/localstorage/jwtStorage";

const AccountBalanceComponent = () => {
  const { selectedWallet, selectedAccount } = useWalletProvider();
  const { backendAuthStatus } = useContext(WalletProviderContext);
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
  const [balance, setBalance] = useState();
  const [currency, setCurrency] = useState();
  const [isBalance, setIsBalance] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const provider = selectedWallet?.provider;

    setBalance(undefined);
    setCurrency(undefined);
    if (!selectedAccount || !provider) {
      return () => {
        cancelled = true;
      };
    }

    async function loadBalance() {
      const logsAndVars = createEmptyLogsAndVars("AccountBalanceComponent:getAccount");
      try {
        const chainId = await provider.request({ method: "net_version" });
        const rawBalance = await provider.request({
          method: "eth_getBalance",
          params: [selectedAccount, "latest"],
        });
        if (cancelled) return;
        const configuredCurrency = WalletCurrency.find((item) => String(item.chain_id) === String(chainId));
        setCurrency(configuredCurrency?.currency ?? "");
        setBalance((parseInt(rawBalance, 16) / 1e18).toFixed(4));
        collectLog(logsAndVars, "setBalance is done");
      } catch (error) {
        if (!cancelled) {
          dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
          setBalance(undefined);
          setCurrency(undefined);
        }
      }
    }

    loadBalance();
    return () => {
      cancelled = true;
    };
  }, [
    selectedAccount,
    selectedWallet?.provider,
  ]);

  useEffect(() => {
    let cancelled = false;
    const provider = selectedWallet?.provider;

    // Never carry a previous wallet's visibility preference into a new
    // wallet while its encrypted profile is still loading.
    setIsBalance(false);
    if (backendAuthStatus !== "authorized" || !selectedAccount || !provider) {
      return () => {
        cancelled = true;
      };
    }

    async function loadProfilePreference() {
      const logsAndVars = createEmptyLogsAndVars("AccountBalanceComponent:loadData");
      recordVariable(logsAndVars, "accountname (param)", selectedAccount);
      try {
        const authToken = (await loadJwt()) ?? "";
        if (authToken === "") return;
        const userProfile = await getUserProfileJwt(provider, authToken);
        if (!cancelled) {
          setIsBalance(userProfile?.showBalance ?? false);
          collectLog(logsAndVars, "setIsBalance is done");
        }
      } catch (error) {
        if (!cancelled) {
          dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
          console.log(error);
        }
      }
    }

    loadProfilePreference();
    return () => {
      cancelled = true;
    };
  }, [
    backendAuthStatus,
    selectedAccount,
    selectedWallet?.provider,
  ]);

  return (
    <>
      {balance ? (
        <div className="balance">
          <div className={isBalance ? "frame" : "frame hidden"}>
            <span className="balance-text">{balance + " " + currency}</span>
          </div>
          <button type="button" className="eye-button" onClick={() => setIsBalance(!isBalance)}>
            <img src={isBalance ? eye : eye_off} alt="eye" />
          </button>
          <div className="div">
            <img className="image" alt="Image" src={selectedWallet?.info?.icon} />
            <div className="frame-2">
              <div className="ellipse" />
            </div>
          </div>
        </div>
      ) : (
        <div className="balance">
          <div className={isBalance ? "frame" : "frame hidden"}>
            <span className="balance-text">0 ETH</span>
          </div>
          <button type="button" className="eye-button" onClick={() => setIsBalance(!isBalance)}>
            <img src={isBalance ? eye : eye_off} alt="eye" />
          </button>
          <div className="div">
            <img className="image" alt="Image" src={selectedWallet?.info?.icon} />
            <div className="frame-2">
              <div className="ellipse" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AccountBalanceComponent;
